/**
 * 手机号+验证码表单项
 */
import { FC, useMemo } from 'react'
import { Form, Input } from 'antd-mobile'
import { useTranslation } from "react-i18next";
import { rules } from '@/pages/user/Login/const'
import { SmsCodeFormItem } from '@/components/SmsCodeFormItem'
import css from './index.module.less'
import { useStoreState } from '@/store'

// model: 发送验证码所需额外参数 包括：type
export const PhoneFormItems: FC<{ form: any, model: any, phoneName?: string }> = ({ form, model, phoneName = 'phone' }) => {
  const { t } = useTranslation();
  const phone = Form.useWatch(phoneName, form);
  const sdk = Form.useWatch('sdk', form);
  const { inner, isPhoneStrate } = useStoreState()

  const computedModel = useMemo(() => ({ ...model, sdk }), [model, sdk])

  return (
    <>
      <Form.Item className={css.InputWrap} name={phoneName} rules={rules.phone}>
        <Input className={css.Input} placeholder={t('user-center.register.in-phone')} clearable />
      </Form.Item>
      {(!inner.isFrom && !isPhoneStrate) && <SmsCodeFormItem name={'code'} phone={phone} model={computedModel} />}
    </>
  )
}
